module.exports = __webpack_public_path__ + "img/ALA.40e67121.svg";